import React from "react";
import {Divider} from "@material-ui/core";
import {IApplicationInternal} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {AppInfoHeaderWrapper, AppLogo, HeaderTitle, HeaderDescription} from "./styles";

interface IProps {
    app: IApplicationInternal;
}

export const InternalAppDetailsHeader = ({app}: IProps) => (
    <>
        <AppInfoHeaderWrapper>
            {app.image && (
                <AppLogo src={app.image}/>
            )}

            <div>
                <HeaderTitle>
                    {app.displayName}
                </HeaderTitle>

                {app.description && (
                    <HeaderDescription>
                        {app.description}
                    </HeaderDescription>
                )}
            </div>
        </AppInfoHeaderWrapper>

        <Divider/>
    </>
)